import { queryOptions } from "@tanstack/react-query"
import type { components } from "@/shared/lib/api.types"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"

export type Sex = components["schemas"]["Sex"]
export type Child = components["schemas"]["ChildDto"]

export const childrenKeys = {
  all: ["children"] as const,
}

export const childrenQueryOptions = queryOptions({
  queryKey: childrenKeys.all,
  queryFn: () => unwrap(apiClient.GET("/api/children")),
})
